import React, { useMemo } from "react";
import useRefCallback from "use-ref-callback";
import IconButton from "@atlas/uicorn/lib/Control/IconButton";
import FilterIcon from "@atlas/uicorn/lib/Icon/FilterIcon";
import ContextMenu from "@atlas/uicorn/lib/Control/ContextMenu";
import { TOptionsListItem } from "@atlas/uicorn/lib/Control/OptionsList";
import { TConversationListFilter } from "../../../lib/load-conversations";
import t from "../../../texts/t";

const FilterMenu = function FilterMenu({
  filter,
  onChange,
  language,
}: TFilterMenuProps) {
  const menuItems = useMemo(
    () => [
      {
        key: StatusFilterKey.all,
        label: t("Show all tickets", language),
      },
      {
        key: StatusFilterKey.open,
        label: t("Show open tickets", language),
      },
      {
        key: StatusFilterKey.closed,
        label: t("Show closed tickets", language),
      },
    ],
    [language]
  );

  const selected = useMemo(
    () =>
      filter?.status
        ? menuItems.filter((i) => i.key === filter?.status)
        : [menuItems[0]],
    [filter, menuItems]
  );

  const handleChoose = useRefCallback((option: TFilterMenuItem) => {
    const { key: status } = option;

    if (filter?.status === status) return;
    if (status === StatusFilterKey.all) return onChange(undefined);
    onChange({ status });
  });

  return (
    <ContextMenu
      items={menuItems}
      selected={selected}
      onChoose={handleChoose}
      placement="bottom-end"
      strategy="fixed"
    >
      <IconButton
        size={24}
        icon={
          <FilterIcon
            color={
              selected[0]?.key !== StatusFilterKey.all ? "primary" : "grey8"
            }
          />
        }
        tooltip=""
      />
    </ContextMenu>
  );
};

export default FilterMenu;

// #region Types

enum StatusFilterKey {
  all = "ALL",
  open = "OPEN",
  closed = "CLOSED",
}

type TFilterMenuItem = TOptionsListItem & { key: "OPEN" | "CLOSED" | "ALL" };

export type TFilterMenuProps = {
  filter: TConversationListFilter | null;
  onChange: (filter?: TConversationListFilter) => void;
  language?: string;
};

// #endregion
